import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TransactionHistory').create(({ theme }) => ({
  root: {
    padding: '12px 0px',
    width: '100%',
    height: '100%',

    h1: {
      fontWeight: '450',
      fontSize: '24px',
      color: theme.colors.text.primary,
      textAlign: 'center',
      lineHeight: '30px',
      margin: '0px',
    },
  },
}))
